import { Box, Heading } from '@chakra-ui/react'

import BlogArticleAuthorQ from '@/queries/BlogArticleAuthorQ'
import BlogArticleQ from '@/queries/BlogArticleQ'
import UserQ from '@/queries/UserQ'
import type { Query } from '@/client/query'

import BlogArticleList from '@/components/Blog/BlogArticleList'
import { useInfiniteScroll } from '@/components/Session/helpers'
import { blogArticleDetailsFromQuery } from '@/components/Worlds/transforms/detailsFromQueries'

export default function ProfileBlogArticles({ user }: { user: Query }): JSX.Element | null {
  const [queryLimit, handleLoadMore] = useInfiniteScroll({ defaultValue: 6 })

  const blogArticles = user
    .many(
      BlogArticleAuthorQ.where(
        {
          userId: UserQ.id,
          include: [
            {
              association: 'BlogArticle',
              required: true,
            },
          ],
          limit: queryLimit,
          order: [[BlogArticleQ.published_at, 'desc']],
        },
        BlogArticleQ.isPublished()
      )
    )
    .map(blogArticleDetailsFromQuery)

  const countTotalItems =
    user<number>`COUNT(*) ${BlogArticleAuthorQ.where(
      {
        userId: UserQ.id,
        include: [
          {
            association: 'BlogArticle',
            required: true,
          },
        ],
      },
      BlogArticleQ.isPublished()
    )}` ?? 0

  if (blogArticles.length === 0) {
    return null
  }

  return (
    <Box>
      <Heading size="xl" mb={6}>
        Blog Articles
      </Heading>
      <BlogArticleList
        blogArticles={blogArticles}
        infiniteScrollConfig={{ queryLimit, handleLoadMore, countTotalItems }}
      />
    </Box>
  )
}
